import React from 'react'
import Flex from 'components/reusable/flex'
import Text from 'components/reusable/text'
import CopyLink from 'components/complex/copy_link'
import BenefitsList from 'components/reusable/benefits_list'
import InviteViaSocials from 'components/views/logged_in/network/referrals_view/invite_via_socials'
import useAdaptiveDesign from 'hooks/use_adaptive_design'
import styled from 'styled-components'

const CompyWrapper = styled(Flex)`
  max-width: 700px;
`

const ReferralShareSectionDesktop = ({ url, showByInvitationOnly = false, referrerRole = 'client' }) => {
  return (
    <>
      <BenefitsList role={referrerRole} />

      <Flex dir="column" ai="flex-start" jc="flex-start" gap={8} width="100%">
        <Text size={16} weight={500}>Share your link:</Text>
        <CompyWrapper width='100%'>
          <CopyLink url={url} width="100%" />
        </CompyWrapper>
      </Flex>

      <Flex dir="column" ai="flex-start" jc="flex-start" gap={8} width="100%">
        <Text size={16} weight={500}>Or invite via:</Text>
        <InviteViaSocials url={url} />
      </Flex>

      {showByInvitationOnly && (
        <Text size={14}>*By invitation only</Text>
      )}
    </>
  )
}

const ReferralShareSectionMobile = ({ url, referrerRole = 'client' }) => {
  return (
    <>
      <BenefitsList role={referrerRole} />

      <Flex dir="column" ai="flex-start" jc="flex-start" gap={8} width="100%">
        <Text size={14} weight={500}>Share your link:</Text>
        <CopyLink url={url} width="100%" />
      </Flex>

      <Flex dir="column" ai="flex-start" jc="flex-start" gap={8} width="100%">
        <Text size={14} weight={500}>Or invite via:</Text>
        <InviteViaSocials url={url} />
      </Flex>
    </>
  )
}

const ReferralShareSection = (props) => {
  const Component = useAdaptiveDesign(ReferralShareSectionDesktop, ReferralShareSectionMobile)
  return <Component {...props} />
}

export { ReferralShareSectionDesktop, ReferralShareSectionMobile }
export default ReferralShareSection
